import { render, staticRenderFns } from "./packageDetalisPopUp.vue?vue&type=template&id=717b2316&scoped=true"
import script from "./packageDetalisPopUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./packageDetalisPopUp.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./packageDetalisPopUp.vue?vue&type=style&index=0&id=717b2316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b2316",
  null
  
)

export default component.exports